import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const supportApi = createAsyncThunk(
    'auth/supports',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.adminAction("write-to-us", 1), { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const supportSlice = createSlice({
    name: 'support',
    initialState: { result: [], loading: false, error: null, message: "", total: 0, },
    extraReducers: (builder) => {
        builder.addCase(supportApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(supportApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count;
        })
        builder.addCase(supportApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const supportReducer = supportSlice.reducer